import { render, staticRenderFns } from "./number.vue?vue&type=template&id=2ec5b592&scoped=true&lang=pug&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"
import style0 from "./number.vue?vue&type=style&index=0&id=2ec5b592&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5b592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ec5b592', component.options)
    } else {
      api.reload('2ec5b592', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=2ec5b592&scoped=true&lang=pug&", function () {
      api.rerender('2ec5b592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/number.vue"
export default component.exports